import * as React from 'react';
import InfoCircleOutline from '../../atoms/Icons/InfoCircleOutline/InfoCircleOutline.js';
import WarningCircleOutline from '../../atoms/Icons/WarningCircleOutline/WarningCircleOutline.js';
import CrossCircleOutline from '../../atoms/Icons/CrossCircleOutline/CrossCircleOutline.js';
import TickCircleOutline from '../../atoms/Icons/TickCircleOutline/TickCircleOutline.js';
import { Notification as Notification$1, NotificationIconWrapper, NotificationContent, NotificationText, NotificationTitle, NotificationBody, NotificationCta } from './Notification.styles.js';

var Notification = function (_a) {
    var title = _a.title, text = _a.text, cta = _a.cta, _b = _a.variant, variant = _b === void 0 ? "default" : _b, _c = _a.style, style = _c === void 0 ? {} : _c;
    var variantToIconMap = {
        warning: WarningCircleOutline,
        success: TickCircleOutline,
        error: CrossCircleOutline,
        info: InfoCircleOutline,
        default: InfoCircleOutline,
    };
    var Icon = variantToIconMap[variant];
    return (React.createElement(Notification$1, { variant: variant, style: style },
        React.createElement(NotificationIconWrapper, { cta: Boolean(cta === null || cta === void 0 ? void 0 : cta.text) },
            React.createElement(Icon, { size: "notice" })),
        React.createElement(NotificationContent, null,
            React.createElement(NotificationText, null,
                title && React.createElement(NotificationTitle, { as: "h5" }, title),
                React.createElement(NotificationBody, { variant: "footnote" }, text)),
            (cta === null || cta === void 0 ? void 0 : cta.text) && (React.createElement(NotificationCta, { variant: "primary", darkMode: true, onClick: function () {
                    // eslint-disable-next-line sonarjs/no-collapsible-if
                    if (cta === null || cta === void 0 ? void 0 : cta.confirm) {
                        // eslint-disable-next-line no-alert
                        if (!window.confirm(cta.confirm))
                            return;
                    }
                    if (cta.href) {
                        window.location.href = cta.href;
                    }
                } }, cta.text)))));
};

export { Notification as default };
//# sourceMappingURL=Notification.js.map
